import { render, staticRenderFns } from "./ActiveService.vue?vue&type=template&id=3901d4f8"
import script from "./ActiveService.vue?vue&type=script&lang=js"
export * from "./ActiveService.vue?vue&type=script&lang=js"
import style0 from "./ActiveService.vue?vue&type=style&index=0&id=3901d4f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports